import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ItemMaintenanceRoutingModule } from './item-maintenance-routing.module';
import { ItemMaintenanceComponent } from './item-maintenance.component';
import { ItemMaintenanceFormComponent } from './item-maintenance-form/item-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { ItemMaintenanceFilterComponent } from './item-maintenance-filter/item-maintenance-filter.component';
import { CategoryDropdownModule } from 'src/app/core/custom-modules/dropdowns/category-dropdown/category-dropdown.module';
import { BrandDropdownModule } from 'src/app/core/custom-modules/dropdowns/brand-dropdown/brand-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    ItemMaintenanceRoutingModule,
    CategoryDropdownModule,
    BrandDropdownModule
  ],
  declarations: [ItemMaintenanceComponent, ItemMaintenanceFormComponent, ItemMaintenanceFilterComponent],
  entryComponents: [ItemMaintenanceFilterComponent]
})
export class ItemMaintenanceModule { }
